import Reveal from "@/components/Reveal";
import GalleryGrid from "@/components/GalleryGrid";
import CTABanner from "@/components/CTABanner";
import useSEO from "@/hooks/useSEO";
import { GALLERIES } from "@/data/site";

export default function ResidentialLandscaping() {
  useSEO("Residential Landscaping");
  return (
    <div data-testid="residential-landscaping-page">
      <section className="bg-[#050505] pt-20 md:pt-28 pb-16 md:pb-20 text-center">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <Reveal><p className="cc-eyebrow justify-center mb-6">Our Services</p></Reveal>
          <Reveal delay={100}>
            <h1 className="font-display font-black uppercase text-5xl sm:text-6xl lg:text-[88px] leading-[0.95] text-white tracking-tight">
              Residential <span className="text-[#F28C00]">Landscaping</span>
            </h1>
          </Reveal>
          <Reveal delay={200}>
            <p className="text-[#9A9A9A] text-base sm:text-lg leading-relaxed mt-8 max-w-2xl mx-auto">
              Driveways, patios, decking, fencing, artificial grass and full garden makeovers — premium outdoor spaces, designed for Scottish living.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="bg-[#0B0B0B] py-20 md:py-24 border-y border-[#181818]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <GalleryGrid images={GALLERIES.landscaping} columns={2} testIdPrefix="landscaping-gallery" />
        </div>
      </section>

      <CTABanner
        eyebrow="Ready To Transform Your Outdoor Space?"
        title="Let's Bring Your Garden To Life"
        testId="landscaping-cta"
      />
    </div>
  );
}
